<template>
<div id="interpretationCreation">
  <b-card no-body class="mb-1">
    <b-card-header header-tag="header" class="p-1" role="tab">
      <b-button block href="#" v-b-toggle.accordion-2>Annotation</b-button>
    </b-card-header>
    <b-collapse id="accordion-2" visible accordion="my-accordion" role="tabpanel">
      <b-card-body>
        <b-card-text>
          <b-tabs content-class="mt-3">
            <b-tab title="Général" active>
              <b-form-group>
                <b-row class="my-1">
                  <b-col sm="5"><label>Réponse </label></b-col>
                  <b-col sm="7">
                    <b-form-select :options="rousselotPhoneticFormList" v-model="interpretation.rousselotPhoneticForm">
                      <option value="" disabled selected>Choix de la réponse</option>
                    </b-form-select>
                  </b-col>
                </b-row>
                <b-alert v-if="!interpretation.rousselotPhoneticForm" show variant="info">Choisir la réponse phonétique associée</b-alert>
                <b-row class="my-1">
                  <b-col sm="5"><label>Confidentialité</label></b-col>
                  <b-col sm="7">
                    <b-form-select :options="confidentialityList" v-model="interpretation.confidentiality"></b-form-select>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="5"><label>Réponse lémmatisée</label></b-col>
                  <b-col sm="7">
                    <b-form-input v-model="interpretation.lemmatizedResponse"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="5"><label>Type</label></b-col>
                  <b-col sm="7">
                    <b-form-select :options="typesList" v-model="interpretation.responseType"></b-form-select>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="5"><label>Motif</label></b-col>
                  <b-col sm="7">
                    <b-form-input v-model="interpretation.ground"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="5">
                    <label>Motif spécifique</label>
                  </b-col>
                  <b-col sm="7">
                    <b-form-input v-model="interpretation.specificGround"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="5">
                    <label>Désignant</label>
                  </b-col>
                  <b-col sm="7">
                    <b-form-input v-model="interpretation.designating"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="5">
                    <label>Commentaire</label>
                  </b-col>

                  <b-button v-b-modal.interpretationCommentModal>Ajouter un commentaire</b-button>
                  <b-modal hide-footer id="interpretationCommentModal" title="Commentaire d'annotation">
                    <editor-comment v-on:addComment="addInterpretationComment"></editor-comment>
                  </b-modal>

                </b-row>
              </b-form-group>
            </b-tab>
            <!--- -LEMMES -->
            <b-tab v-for="(lemma, lemmasIndex) in tabs.lemmas" :title="'Lemme ' + (lemma+1)" :key="lemma">
              <b-row class="my-1" v-if="lemmasIndex != 0">
                <b-button size="sm" variant="danger" class="float-right" @click="closeLemmaTab(lemmasIndex)">
                  Supprimer Lemme
                </b-button>
              </b-row>
              <br>
              <b-form-group>
                <b-row class="my-1">
                  <b-col sm="5">
                    <label>Nature grammaticale</label>
                  </b-col>
                  <b-col sm="7">
                    <b-form-select :options="grammaticalNatureList" v-model="interpretation.lemmasList[lemmasIndex].grammaticalNature"></b-form-select>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="5">
                    <label>Genre</label>
                  </b-col>
                  <b-col sm="7">
                    <b-form-select :options="genderList" v-model="interpretation.lemmasList[lemmasIndex].gender"></b-form-select>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="5">
                    <label>Nombre</label>
                  </b-col>
                  <b-col sm="7">
                    <b-form-select :options="numberList" v-model="interpretation.lemmasList[lemmasIndex].number"></b-form-select>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="5">
                    <label>Commentaire</label>
                  </b-col>
                  <b-col sm="7">
                    <b-button v-b-modal="`lemmaCommentModal` + lemmasIndex" @click="saveIndex(lemmasIndex, null)">Ajouter un commentaire</b-button>
                    <b-modal hide-footer :id="`lemmaCommentModal` + lemmasIndex" title="Commentaire de lemme">
                      <editor-comment v-on:addComment="addLemmaComment"></editor-comment>
                    </b-modal>
                  </b-col>
                </b-row>
              </b-form-group>
              <br>
              <!-- ETYMONS -->
              <h5> Étymons du lemme {{ lemma + 1}}</h5>
              <b-tabs pills card vertical>
                <b-tab v-for="(etymon, etymonsIndex) in tabs.lemmasTabs[lemmasIndex].etymonTabs" :title="'Etymon ' + (etymonsIndex + 1)" :key="etymon + '_' + lemma">
                  <b-row class="my-1" v-if="etymonsIndex != 0">
                    <b-button size="sm" variant="danger" class="float-right" @click="closeEtymonTab(etymonsIndex, lemmasIndex)">
                      Supprimer Étymon
                    </b-button>
                  </b-row>
                  <b-form-group>
                    <b-row class="my-1">
                      <b-col sm="5">
                        <label> Niveau de confiance</label>
                      </b-col>
                      <b-col sm="7">
                        <b-form-select :options="uncertaintyList" v-model="interpretation.lemmasList[lemmasIndex].etymonsList[etymonsIndex].uncertainty"></b-form-select>
                      </b-col>
                    </b-row>
                    <b-row class="my-1">
                      <b-col sm="5">
                        <label> Étymon FEW</label>
                      </b-col>
                      <b-col sm="7">
                        <b-form-input v-model="interpretation.lemmasList[lemmasIndex].etymonsList[etymonsIndex].fewEtymon"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="my-1">
                      <b-col sm="5">
                        <label>Origine langue</label>
                      </b-col>
                      <b-col sm="7">
                        <b-form-select :options="languageEtymonList" v-model="interpretation.lemmasList[lemmasIndex].etymonsList[etymonsIndex].fewEtymonLanguage"></b-form-select>
                      </b-col>
                    </b-row>
                    <b-row class="my-1">
                      <b-col sm="5">
                        <label> Signifié</label>
                      </b-col>
                      <b-col sm="7">
                        <b-form-input v-model="interpretation.lemmasList[lemmasIndex].etymonsList[etymonsIndex].fewEtymonSignified"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="my-1">
                      <b-col sm="5">
                        <label> Ref. FEW</label>
                      </b-col>
                      <b-col sm="7">
                        <b-form-input v-model="interpretation.lemmasList[lemmasIndex].etymonsList[etymonsIndex].fewEtymonReference"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="my-1">
                      <b-col sm="5">
                        <label> Commentaire étymon</label>
                      </b-col>
                      <b-col sm="7">
                        <b-button v-b-modal="`etymonCommentModal` + lemmasIndex + `_` + etymonsIndex" @click="saveIndex(lemmasIndex, etymonsIndex)">Ajouter un commentaire</b-button>
                        <b-modal hide-footer :id="`etymonCommentModal` + lemmasIndex + `_` + etymonsIndex" title="Commentaire d'Étymon">
                          <editor-comment v-on:addComment="addEtymonComment"></editor-comment>
                        </b-modal>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-tab>
                <template v-slot:tabs-end>
                  <b-nav-item @click.prevent="newEtymonTab(lemmasIndex)" href="#"><b>+</b></b-nav-item>
                </template>
              </b-tabs>
            </b-tab>
            <template v-slot:tabs-end>
              <b-nav-item @click.prevent="newLemmaTab" href="#"><b>+</b></b-nav-item>
            </template>
          </b-tabs>
        </b-card-text>
      </b-card-body>
    </b-collapse>
  </b-card>

  <b-card no-body class="mb-1">
    <b-card-header header-tag="header" class="p-1" role="tab">
      <b-button block href="#" v-b-toggle.accordion-2>Gestion de la propagation</b-button>
    </b-card-header>
    <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
      <b-card-body>
        <b-card-text>
          <b-row class="my-1">
            <b-col sm="7">
              Propager aux {{ countOfIdenticalResponses }} réponses identiques
            </b-col>
            <b-col sm="5">
              <b-form-checkbox id="checkbox-2" v-model="propagation" name="checkbox-2" value="oui" unchecked-value="non">
                {{ propagation }}
              </b-form-checkbox>
            </b-col>
          </b-row>
          <br>
          <b-row class="my-1">
            <b-col sm="5">
              <label> Indice de Levensthein </label>
            </b-col>
            <b-col sm="7">
              <b-form-input v-model="levenshteinDistance" @change="applyLevenshtein()" type="number" step="1" min="0" max="20"></b-form-input>
            </b-col>
          </b-row>
          <div v-if=" Object.keys(levenshteinList).length === 0">
            Pas de correspondance - augmenter l'indice de levenshtein
          </div>
          <b-form-checkbox-group v-model="interpretation.levenshteinList">
            <b-form-checkbox class="checkboxes" :value="property" v-for="property in Object.keys(levenshteinList)" :key="property">
              {{property}} - (Distance : {{levenshteinList[property][0]}} - Occurrence: {{levenshteinList[property][1]}})
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-card-text>
      </b-card-body>

    </b-collapse>
  </b-card>
  <b-button v-if="interpretation.rousselotPhoneticForm" variant="success" @click="submit(), $emit('closeInterpretationCreation')">Enregistrer</b-button>
  <b-button variant="danger" v-on:click="$emit('closeInterpretationCreation')">Annuler</b-button>

</div>
</template>

<script>
import { mapGetters } from 'vuex'
import EditorComment from '@components/commons/EditorComment'

export default {
  name: 'InterpretationsCreation',
  props: ['rousselotPhoneticFormList'],
  components: { EditorComment },
  computed: {
    ...mapGetters({
      currentInventoryEntry: 'getCurrentInventoryEntry',
      currentMap: 'getCurrentMap',
      invEntrySameRousselotPhoneticFormList: 'getInvEntrySameRousselotPhoneticFormList',
      countOfIdenticalResponses: 'getCountOfIdenticalResponses',
      levenshteinList: 'getLevenshteinList',
      currentUser: 'getCurrentUser',
      // Listes énumérées
      typesList: 'getTypesList',
      grammaticalNatureList: 'getGrammaticalNatureList',
      languageEtymonList: 'getLanguageEtymonList',
      uncertaintyList: 'getUncertaintyList',
      genderList: 'getGenderList',
      numberList: 'getNumberList',
      confidentialityList: 'getConfidentialityList'
    })
  },
  watch: {
    // Permet de mettre à jour la liste issue de levenshtein si l'utilisateur clique sur un nouveau
    // points d'enquête lors de la création d'annotation
    currentInventoryEntry() {
      this.currentInventoryEntry
      this.applyLevenshtein()
      this.loadCountOfIdenticalResponses()
    }
  },
  created() {
    // Rechargement des disques (cas où l'utilisateur créé une nouvelle interprétation alors qu'il en consultait une autre (les disques étaient verts))
    this.$store.dispatch('displayCircle', 'interpretations')

    this.interpretation.confidentiality = this.confidentialityList[0]
    this.interpretation.inventoryEntry = this.currentInventoryEntry.inventoryEntry
    this.interpretation.mapId = this.currentMap
    this.applyLevenshtein()
    this.loadCountOfIdenticalResponses()
  },
  methods: {
    // Envoi du formulaire d'ajout d'interprétation au store
    submit: function() {
      this.interpretation.author =  this.currentUser.username
      this.interpretation.spreading = this.propagation === "oui" ? "true" : "false"
      this.$store.dispatch('addInterpretation', this.interpretation)
    },
    // nombre de réponses identiques à la réponses de l'entrée d'inventaire cliquée
    loadCountOfIdenticalResponses: function() {
      return this.$store.dispatch('findCountOfIdenticalResponses', {
        mapId: this.currentMap,
        rousselotPhoneticForm: this.currentInventoryEntry.rousselotPhoneticForm
      })
    },
    // Applique la distance de levenshtein indiquée dans l'input dédié
    applyLevenshtein: function() {
      return this.$store.dispatch('findLevenshteinCorrespondance', {
        mapId: this.currentMap,
        rousselotPhoneticForm: this.currentInventoryEntry.rousselotPhoneticForm,
        levenshteinDistance: this.levenshteinDistance,
        author: this.currentUser.username
      })
    },

    // ---------------------------------------------------------------------------------------------
    // GESTION DES COMMENTAIRES
    // ---------------------------------------------------------------------------------------------

    // Permet de sauvegarder l'index du lemme et éventuellement de l'étymon pour
    // la sauvegarde du commentaire associé à un lemme ou à un étymon donné
    saveIndex: function(lemmasIndex, etymonsIndex) {
      this.lemmasIndex = lemmasIndex
      this.etymonsIndex = etymonsIndex
    },
    // Ajout d'un commentaire global à l'interprétation
    addInterpretationComment: function(comment) {
      this.interpretation.interpretationComment = comment
      this.$bvModal.hide('interpretationCommentModal')
    },
    // Ajout d'un commentaire de lemme
    addLemmaComment: function(comment) {
      this.interpretation.lemmasList[this.lemmasIndex].lemmaComments = comment
      this.$bvModal.hide('lemmaCommentModal' + this.lemmasIndex)
    },
    // Ajout d'un commentaire d'étymon
    addEtymonComment: function(comment) {
      this.interpretation.lemmasList[this.lemmasIndex].etymonsList[this.etymonsIndex].etymonComment = comment
      this.$bvModal.hide('etymonCommentModal' + this.lemmasIndex + "_" + this.etymonsIndex)
    },

    // ---------------------------------------------------------------------------------------------
    // GESTION DES ONGLETS (TABS)
    // ---------------------------------------------------------------------------------------------

    // Fonction qui gère l'ajout de lemmes dans le formulaire de création d'interprétation
    newLemmaTab: function() {
      this.interpretation.lemmasList.push({
        grammaticalNature: '',
        gender: '',
        number: '',
        lemmaComments: '',
        etymonsList: [{
          uncertainty: '',
          fewEtymon: '',
          fewEtymonLanguage: '',
          fewEtymonSignified: '',
          fewEtymonReference: '',
          etymonComment: ''
        }]
      })
      this.tabs.lemmas.push(this.tabs.lemmaTabsCounter++)
      this.tabs.lemmasTabs.push({
        etymonTabs: [0],
        etymonsTabsCounter: 1
      })
    },
    // Fonction qui gère l'ajout d'étymon dans le formulaire de création d'interprétation
    newEtymonTab: function(lemmasIndex) {
      this.interpretation.lemmasList[lemmasIndex].etymonsList.push({
        uncertainty: '',
        fewEtymon: '',
        fewEtymonLanguage: '',
        fewEtymonSignified: '',
        fewEtymonReference: '',
        etymonComment: ''
      })
      this.tabs.lemmasTabs[lemmasIndex].etymonTabs.push(this.tabs.etymonsTabsCounter++)
    },
    // Fonction qui supprime un lemme dans le formulaire de création d'interprétation
    closeLemmaTab(lemmasIndex) {
      for (let i = 0; i < this.tabs.lemmas.length; i++) {
        if (this.tabs.lemmas[i] === lemmasIndex) {
          this.tabs.lemmas.splice(i, 1)
        }
      }
    },
    // Fonction qui supprime un étymon dans le formulaire de création d'interprétation
    closeEtymonTab(etymonsIndex, lemmasIndex) {
      for (let i = 0; i < this.tabs.lemmasTabs[lemmasIndex].etymonTabs.length; i++) {
        if (this.tabs.lemmasTabs[lemmasIndex].etymonTabs[i] === etymonsIndex) {
          this.tabs.lemmasTabs[lemmasIndex].etymonTabs.splice(i, 1)
        }
      }
    }
  },

  data() {
    return {
      propagation: "oui",
      levenshteinDistance: 1,
      lemmasIndex: null,
      etymonsIndex: null,
      // Les 'tabs' permettant de naviguer entre les lemmes, étymons du formulaire
      tabs: {
        lemmas: [0],
        lemmasTabs: [{
          etymonTabs: [0],
        }],
        etymonsTabsCounter: 1,
        lemmaTabsCounter: 1
      },
      // Le formulaire de création interprétation
      interpretation: {
        inventoryEntry: '',
        rousselotPhoneticForm: '',
        mapId: '',
        author: '',
        confidentiality: '',
        spreading: "true",
        levenshteinList: [],
        lemmatizedResponse: '',
        responseType: '',
        ground: '',
        specificGround: '',
        designating: '',
        interpretationComment: '',
        lemmasList: [{
          grammaticalNature: '',
          gender: '',
          number: '',
          lemmaComments: '',
          etymonsList: [{
            uncertainty: '',
            fewEtymon: '',
            fewEtymonLanguage: '',
            fewEtymonSignified: '',
            fewEtymonReference: '',
            etymonComment: ''
          }]
        }]
      }
    }
  },
}
</script>
<style>
#interpretationCreation {
  padding: 15px;
}


.modal-content {
  margin-top: 30%;
  color: black;
  background-color: white !important;
}

.checkboxes {
  width: 400px;
  position: relative;
  left: 50px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/sideBarViewer/interpretationsSideBar/InterpretationsCreation.vue